/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TrendTileSettingsDto } from './trend-tile-settings-dto';
import { FilterBindingDto } from './filter-binding-dto';
import { TileLocalizedTitleDto } from './tile-localized-title-dto';


export interface AddItemDto { 
    /**
     * Published KPI definition to add as a dashboard tile.
     */
    kpiId: string;
    /**
     * Pin a specific version. Omit to serve the KPI\'s published version.
     */
    kpiVersionId?: string;
    /**
     * Sort order for this item within the dashboard.
     */
    order?: number;
    /**
     * Optional display title for this dashboard item, in English; falls back to the localized KPI title.
     */
    titleOverride?: string;
    /**
     * The tile\'s title override in languages other than English, keyed by two-letter lowercase language code, at most 20 languages, for example {\"de\": {\"titleOverride\": \"Neue Mitglieder\"}, \"cs\": {\"titleOverride\": \"Noví členové\"}}. English goes in the plain titleOverride; an en key is rejected. A client shows the entry for the viewer\'s language, else the plain titleOverride. With neither, the tile shows the KPI title in the viewer\'s language. Omitted or null: no translations.
     */
    i18n?: { [key: string]: TileLocalizedTitleDto; } | null;
    /**
     * Visibility status for this dashboard item.
     */
    status?: AddItemDto.StatusEnum;
    /**
     * Freeform tile layout state owned by the UI.
     */
    layout?: { [key: string]: any; };
    /**
     * Mappings from dashboard filters to KPI parameters for this tile.
     */
    filterBindings?: Array<FilterBindingDto>;
    /**
     * Trend tiles only: what the tile compares with. Omitted or null means [previous_period]. Ignored on tiles of other KPI types.
     */
    trend?: TrendTileSettingsDto | null;
}
export namespace AddItemDto {
    export const StatusEnum = {
        Visible: 'visible',
        Hidden: 'hidden'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


